import { Component } from "react";
import { connect, ConnectedComponent, Provider } from "react-redux";
import thunkMiddleware from "redux-thunk";
import { createStore, applyMiddleware, compose, Store } from "redux";
import { IStore, Step } from "../../../DataTypes/storeTypes";
import { onLoggedIn } from "../../../Actions/loginActions";

import { IInitialSettings, IStore as IAccountStore, State } from "../../../../Account/DataTypes/storeTypes";
import * as AccountActions from "../../../../Account/Actions/actions";
import * as AccountStoreManager from "../../../../Account/storeManager";
import { rootReducer } from "../../../../Account/Reducers/root";
import * as AccountModel from "../../../../Common/accountModel";
import { dispatchEvent, EventNames } from "../../../../portalEvents";

import { LocalLoginConnected } from "./Login";

class LoginWrapper extends Component<IInitialSettings> {
    store: Store<IAccountStore>;

    constructor(props: IInitialSettings) {
        super(props);

        const data = AccountStoreManager.getDefaultState(props);

        //in order to use redux devtools extension
        const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;
        this.store = createStore(rootReducer, data, composeEnhancers(applyMiddleware(thunkMiddleware)));
    }

    render() {
        return (
            <Provider store={this.store}>
                <LocalLoginConnected />
            </Provider>
        );
    }

    componentDidMount() {
        this.store.dispatch(AccountActions.updateState(State.Login));
    }
}

const mapStateToProps = (state: IStore, ownProps: IInitialSettings): IInitialSettings => {
    return {
        ...state.initialSettings.accountInitialSettings,
        ...ownProps,
        supplierId: state.stepsInfo[Step.Provider].id,
    };
};

const mapDispatchToProps = (dispatch, ownProps: IInitialSettings): IInitialSettings => {
    return {
        ...ownProps,
        onLoggedIn: (data: AccountModel.IAccountModel) => {
            dispatch(onLoggedIn(data));
            dispatchEvent(EventNames.LoginStatusUpdate, data);
        },
    };
};

export const LoginWrapperConnected: ConnectedComponent<typeof LoginWrapper, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginWrapper);
